import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REPORTS_ENDPOINT } from 'src/constants/api';

import { setHeaders } from './base';

const reportsBaseQuery = fetchBaseQuery({
  baseUrl: REPORTS_ENDPOINT,
  mode: 'cors',
  prepareHeaders: setHeaders,
});

export const reportsApi = createApi({
  reducerPath: 'reportsApi',
  baseQuery: reportsBaseQuery,
  endpoints: (builder) => ({
    getDealReport: builder.query({
      query: ({
        type,
        accountId,
        from,
        to,
      }: {
        type: string;
        accountId: number;
        from: string;
        to: string;
      }) => ({
        url: `/deals/analytics/${type}`,
        method: 'GET',
        params: {
          account_id: accountId,
          from,
          to,
        },
      }),
    }),
  }),
});

export const { useGetDealReportQuery, useLazyGetDealReportQuery } = reportsApi;
